import React, { useRef, useState } from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { BADGE_COLORS } from "../../../../components/ui/badgeColors";
import { useAlmacenes } from "../../hooks/useAlmacenes";

/**
 * Punteo por referencia o EAN, escrito o con lector USB/Bluetooth (emula
 * teclado y manda Enter). Cada coincidencia exacta llama a onPuntear(linea), que
 * devuelve { almacen, cantidad } o null si la línea aún no tiene nave activa;
 * el campo se vacía y conserva el foco para escanear el siguiente sin tocar nada
 */
const BuscadorConteo = ({ lineas, onPuntear, disabled }) => {
    const [texto, setTexto] = useState("");
    const [error, setError] = useState(null);
    const [ultimo, setUltimo] = useState(null);
    const inputRef = useRef(null);
    const { getNombreAlmacen } = useAlmacenes();

    const handleSubmit = (evento) => {
        evento.preventDefault();
        const buscado = texto.trim().toLowerCase();
        if (!buscado) return;

        const linea = lineas.find(
            (item) => item.referencia.toLowerCase() === buscado || item.ean?.toLowerCase() === buscado
        );
        setTexto("");
        inputRef.current?.focus();

        if (!linea) {
            setUltimo(null);
            setError(`"${texto.trim()}" no está en este inventario.`);
            return;
        }
        const resultado = onPuntear(linea);
        if (!resultado) {
            setUltimo(null);
            setError(`Elige la nave donde cuentas antes de puntear ${linea.referencia}.`);
            return;
        }
        setError(null);
        setUltimo({ referencia: linea.referencia, ...resultado });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
            <TextField
                fullWidth
                size="small"
                autoFocus
                inputRef={inputRef}
                placeholder="Escanea o escribe referencia / EAN para sumar 1"
                value={texto}
                onChange={(evento) => {
                    setTexto(evento.target.value);
                    if (error) setError(null);
                }}
                disabled={disabled}
                error={Boolean(error)}
                helperText={
                    error ||
                    (ultimo ? (
                        <Typography component="span" sx={{ fontSize: 12, fontWeight: 600, color: BADGE_COLORS.GREEN.text }}>
                            +1 {ultimo.referencia} en {getNombreAlmacen(ultimo.almacen)} → {ultimo.cantidad}
                        </Typography>
                    ) : (
                        " "
                    ))
                }
            />
            <IconButton type="submit" aria-label="Puntear artículo" disabled={disabled} sx={{ color: "#cc071e" }}>
                <QrCodeScannerIcon />
            </IconButton>
        </Box>
    );
};

export default BuscadorConteo;
